<mat-toolbar color="primary">
  <mat-toolbar-row>
    @if (showSideBarMenu) {
      <button mat-icon-button class="menu-button" (click)="toggleSidebar()">
        <mat-icon>menu</mat-icon>
      </button>
    }
    <a href="https://www.empirxhealth.com" target="_blank" rel="noopener noreferrer">
      <img class="brand" src="../../../../assets/images/brand-logo/logo.svg" width="95" alt="EmpiRx"></a>
      <span class="spacer"></span>
      @if (showClientName) {
        <span class="header-title client-name">{{clientName}}</span>
      }
      @if (showClientName) {
        <span class="header-title">|</span>
      }
      <span class="header-title">{{userName}}</span>

      <button mat-icon-button class="logout-button" (click)="openDialog()">
        <mat-icon>power_settings_new</mat-icon>
      </button>
    </mat-toolbar-row>
  </mat-toolbar>